






















import {Component, Vue, Prop} from 'vue-property-decorator';
import Building from '@/data/models/building';
import BuildingCard from '@/components/buildings/BuildingCard.vue';
import Button from '@/components/commons/Button.vue';
import EmptyData from '@/components/commons/EmptyData.vue';

@Component({
  components: {EmptyData, BuildingCard, Button},
})
export default class ListBuildings extends Vue {
  @Prop()
  uid: string;

  buildings: Array<Building> = [];

  get breadCrumb(): string {
    return this.$store.state.breadcrumbName;
  }

  get isLoading(): boolean {
    return this.$store.state.loading;
  }

  mounted(): void {
    this.$store.commit('showLoader', true);

    // Set breadcrum data
    this.$dao.clients
        .getClientById(this.uid)
        .then((result) => {
          this.$store.commit('setBreadCrumbName', `| ${result.nameSurname}`);
        });

    this.$dao.buildings
        .getAllByUserId(this.uid)
        .then((result) => {
          if (result != null) {
            this.buildings = result;
            this.buildings.sort((a, b) => a.name.localeCompare(b.name));
          } else {
            this.$dialog.error({text: this.$t('errors.getBuildings').toString(), title: this.$t('errors.error').toString(), actions: ['Fermer']});
          }
        })
        .catch(() => this.$dialog.error({text: this.$t('errors.getBuildings').toString(), title: this.$t('errors.error').toString(), actions: ['Fermer']}))
        .finally(() => this.$store.commit('showLoader', false));
  }

  addButton(): void {
    this.$router.push({name: 'createUpdateBuilding', params: {'uid': this.uid}});
  }

  updateButton(id: string): void {
    this.$router.push({name: 'createUpdateBuilding', params: {'uid': this.uid}, query: {'buildingId': id}});
  }
}
